export const all_routes = {
  // dashboard routes
  adminDashboard: "/index",
  analyticsDashboard: "/analytics-dashboard",
  employeeDashboard: "/employee-dashboard",
  leadsDashboard: "/leads-dashboard",
  dealsDashboard: "/deals-dashboard",
  cmsLeadDashboard: "/cms-lead-dashboard",
  cmsDealDashboard: "/cms-deal-dashboard",
  bulkUpload: "/cms-bulk-upload",
  userCall: "/cms-user-call",

  //Application routes
  chat: "/application/chat",
  voiceCall: "/application/voice-call",
  videoCall: "/application/video-call",
  outgoingCall: "/application/outgoing-call",
  incomingCall: "/application/incoming-call",
  callHistory: "/application/call-history",
  todo: "/application/todo",
  TodoList: "/application/todo-list",
  email: "/application/email",
  EmailReply: "/application/email-reply",
  audioCall: "/application/audio-call",
  fileManager: "/application/file-manager",
  activityCalendar: "/application/activity-calendar",
  moodMeter: "/application/mood-meter",
  moodQuestions: "/application/mood-questions",
  moodQuestionnaire: "/application/mood-questionnaire",
  accessFile: "/application/access-file",
  socialFeed: "/application/social-feed",
  kanbanView: "/application/kanban-view",
  invoice: "/application/invoices",

  //super admin module
  superAdminDashboard: "/super-admin/dashboard",
  superAdminCompanies: "/super-admin/companies",
  superAdminSubscriptions: "/super-admin/subscription",
  superAdminPackages: "/super-admin/package",
  superAdminPackagesGrid: "/super-admin/package-grid",
  superAdminDomain: "/super-admin/domain",
  superAdminPurchaseTransaction: "/super-admin/purchase-transaction",

  calendar: "/calendar",
  dataTables: "/data-tables",
  tablesBasic: "/tables-basic",
  notes: "/notes",

  //page module
  starter: "/starter",
  profile: "/pages/profile",
  gallery: "/gallery",
  searchresult: "/search-result",
  timeline: "/timeline",
  pricing: "/pricing",
  comingSoon: "/coming-soon",
  underMaintenance: "/under-maintenance",
  underConstruction: "/under-construction",
  error404: "/error-404",
  error500: "/error-500",
  apikey: "/api-keys",
  privacyPolicy: "/privacy-policy",
  termscondition: "/terms-condition",

  // auth routes routes
  login: "/login",
  login2: "/login-2",
  login3: "/login-3",
  register: "/register",
  register2: "/register-2",
  register3: "/register-3",
  forgotPassword: "/forgot-password",
  forgotPassword2: "/forgot-password-2",
  forgotPassword3: "/forgot-password-3",
  twoStepVerification: "/two-step-verification",
  twoStepVerification2: "/two-step-verification-2",
  twoStepVerification3: "/two-step-verification-3",
  success: "/success",
  emailVerification: "/email-verification",
  emailVerification2: "/email-verification-2",
  emailVerification3: "/email-verification-3",
  lockScreen: "/lock-screen",
  resetPassword: "/reset-password",
  resetPassword2: "/reset-password-2",
  resetPassword3: "/reset-password-3",
  resetPasswordSuccess: "/success",
  resetPasswordSuccess2: "/success-2",
  resetPasswordSuccess3: "/success-3",

  //orgination routes
  orginationChart: "/orgination-chart",

  //ui routes
  alert: "/ui-alert",
  accordion: "/ui-accordion",
  avatar: "/ui-avatar",
  badges: "/ui-badges",
  border: "/ui-border",
  breadcrums: "/ui-breadcrums",
  button: "/ui-buttons",
  buttonGroup: "/ui-button-group",
  cards: "/ui-cards",
  carousel: "/ui-carousel",
  colors: "/ui-colors",
  dropdowns: "/ui-dropdowns",
  grid: "/ui-grid",
  images: "/ui-images",
  lightbox: "/ui-lightbox",
  media: "/ui-media",
  modals: "/ui-modals",
  navTabs: "/ui-navtabs",
  offcanvas: "/ui-offcanvas",
  pagination: "/ui-pagination",
  placeholder: "/ui-placeholder",
  popover: "/ui-popover",
  progress: "/ui-progress",
  rangeSlider: "/ui-rangeslider",
  spinner: "/ui-spinner",
  sweetalert: "/sweetalert",
  toasts: "/ui-toasts",
  tooltip: "/ui-tooltip",
  typography: "/ui-typography",
  video: "/ui-video",
  clipboard: "/ui-clipboard",
  counter: "/ui-counter",
  dragandDrop: "/ui-drag-drop",
  rating: "/ui-rating",
  ribbon: "/ui-ribbon",
  stickyNotes: "/ui-sticky-notes",
  textEditor: "/ui-text-editor",
  timeLine: "/ui-timeline",
  scrollBar: "/ui-scrollbar",
  apexChart: "/ui-apexchart",
  primeChart: "/ui-prime-chart",
  chartJs: "/ui-chart-js",

  chart: "/ui-chartjs",
  featherIcons: "/ui-feather-icon",
  falgIcons: "/ui-flag-icon",
  fontawesome: "/ui-fontawesome",
  materialIcon: "/ui-material-icon",
  pe7icon: "/ui-icon-pe7",
  simpleLineIcon: "/ui-simpleline",
  themifyIcon: "/ui-themify",
  typicon: "/ui-typicon",
  weatherIcon: "/ui-weather-icon",
  basicInput: "/forms-basic-input",
  checkboxandRadion: "/form-checkbox-radios",
  inputGroup: "/form-input-groups",
  gridandGutters: "/form-grid-gutters",
  formSelect: "/form-select",
  formMask: "/form-mask",
  fileUpload: "/form-fileupload",
  horizontalForm: "/form-horizontal",
  formPicker: "/form-pickers",
  verticalForm: "/form-vertical",
  floatingLable: "/form-floating-labels",
  formValidation: "/form-validation",
  reactSelect: "/select",
  formWizard: "/form-wizard",
  iconicIcon: "/icon-ionic",
  sortable: "/ui-sortable",
  swiperjs: "/ui-swiperjs",
  bootstrapIcons: "/icon-bootstrap",
  RemixIcons: "/icon-remix",
  FlagIcons: "/icon-flag",

  //base-ui
  uiAlerts: "/ui-alerts",
  uiAccordion: "/ui-accordion",
  uiAvatar: "/ui-avatar",
  uiBadges: "/ui-badges",
  uiBorders: "/ui-borders",
  uiButtons: "/ui-buttons",
  uiButtonsGroup: "/ui-buttons-group",
  uiBreadcrumb: "/ui-breadcrumb",
  uiCards: "/ui-cards",
  uiCarousel: "/ui-carousel",
  uiColor: "/ui-color",
  uiDropdowns: "ui-dropdowns",

  //Maps
  mapLeaflet: "/map-leaflet",

  // settings routes
  customFields: "/app-settings/custom-fields",
  invoiceSettings: "/app-settings/invoice-settings",

  currencies: "/financial-settings/currencies",
  paymentGateways: "/financial-settings/payment-gateways",
  taxRates: "/financial-settings/tax-rates",

  schoolSettings: "/academic-settings/school-settings",
  religion: "/academic-settings/religion",

  connectedApps: "/general-settings/connected-apps",
  notificationssettings: "/general-settings/notifications-settings",
  profilesettings: "/general-settings/profile-settings",
  securitysettings: "/general-settings/security-settings",

  bussinessSettings: "/website-settings/bussiness-settings",
  seoSettings: "/website-settings/seo-settings",
  localizationSettings: "/website-settings/localization-settings",
  prefixes: "/website-settings/prefixes",
  preference: "/website-settings/preferences",
  appearance: "/website-settings/appearance",
  authenticationSettings: "/website-settings/authentication-settings",
  aiSettings: "/website-settings/ai-settings",

  salarySettings: "/app-settings/salary-settings",
  approvalSettings: "/app-settings/approval-settings",
  leaveType: "/app-settings/leave-type",

  banIpAddress: "/other-settings/ban-ip-address",
  customCss: "/other-settings/custom-css",
  customJs: "/other-settings/custom-js",
  cronjob: "/other-settings/cronjob",
  Cronjobschedule: "/other-settings/cronjob-schedule",
  storage: "/other-settings/storage-settings",
  backup: "/other-settings/backup",
  clearcache: "/other-settings/clear-cache",

  emailSettings: "/system-settings/email-settings",
  emailTemplates: "/configurations/email-templates",
  emailTemplateCreate: "/configurations/email-templates/new",
  emailTemplateEdit: "/configurations/email-templates/:id/edit",
  emailTemplateVersions: "/configurations/email-templates/:id/versions",
  gdprCookies: "/system-settings/gdpr-cookies",
  smsSettings: "/system-settings/sms-settings",
  smsTemplate: "/system-settings/sms-template",
  otpSettings: "/system-settings/otp-settings",
  maintenanceMode: "/system-settings/maintenance-mode",

  socialAuthentication: "/website-settings/social-authentication",
  companySettings: "/website-settings/company-settings",
  language: "/website-settings/language",
  addLanguage: "/website-settings/add-language",
  languageWeb: "/website-settings/language-web",
  localization: "/website-settings/localization",

  //content routes
  pages: "/content/pages",
  countries: "countries",
  states: "/content/states",
  cities: "/content/cities",
  testimonials: "testimonials",
  faq: "faq",

  // blog
  blogs: "blogs",
  blogCategories: "blog-categories",
  blogComments: "blog-comments",
  blogTags: "blog-tags",

  //userManagement routes
  deleteRequest: "/user-management/delete-request",
  rolesPermissions: "/user-management/roles-permissions",
  manageusers: "/user-management/manage-users",
  permissions: "/user-management/permissions",

  //support routes
  contactMessages: "/support/contact-messages",
  tickets: "/tickets/ticket-list",
  ticketsAssigned: "/tickets/ticket-assigned",
  ticketGrid: "/tickets/ticket-grid",
  ticketList: "/support/ticket-list",
  ticketDetails: "/tickets/ticket-details",

  // Performance

  performanceIndicator: "/performance/performance-indicator",
  performanceReview: "/performance/performance-review",
  performanceAppraisal: "/preformance/performance-appraisal",
  goalTracking: "/performance/goal-tracking",
  goalType: "/performance/goal-type",

  // Training

  trainingList: "/training/training-list",
  trainers: "/training/trainers",
  trainingType: "/training/training-type",

  // membership routes
  membershipplan: "/membership-plans",
  membershipAddon: "/membership-addons",
  membershipTransaction: "/membership-transactions",

  layoutDefault: "/layout-default",
  layoutMini: "/layout-mini",
  layoutRtl: "/layout-rtl",
  layoutBox: "/layout-box",
  layoutDark: "/layout-dark",
  Horizontal: "/layout-horizontal",
  Detached: "/layout-detached",
  Hovered: "/layout-hovered",
  Boxed: "/layout-box",
  Modern: "/layout-modern",
  TwoColumn: "/layout-twocolumn",
  HorizontalSingle: "/layout-horizontal-single",
  HorizontalOverlay: "/layout-horizontal-overlay",
  HorizontalBox: "/layout-horizontal-box",
  MenuAside: "/layout-horizontal-sidemenu",
  Transparent: "/layout-transparent",
  WithoutHeader: "/layout-without-header",
  RTL: "/layout-rtl",
  Dark: "/layout-dark",

  // finance & accounts routes
  accountsIncome: "/accounts/accounts-income",
  accountsInvoices: "/accounts/accounts-invoices",
  accountsTransactions: "/accounts/accounts-transactions",
  expense: "/accounts/expense",
  expenseCategory: "/accounts/expense-category",

  addInvoice: "/accounts/add-invoice",
  editInvoice: "/accounts/edit-invoice",
  categories: "/accounting/categories",
  budgets: "/accounting/budgets",
  budgetexpenses: "/accounting/budgets-expenses",
  budgetrevenues: "accounting/budget-revenues",

  //crm

  clientgrid: "/clients-grid",
  clientlist: "/clients",
  clientdetils: "/clients-details",
  project: "/projects-grid",
  projectlist: "/projects-old-list",
  projectdetails: "/projects-details",
  tasks: "/tasks",
  sprints: "/sprints-old",
  tasksdetails: "/task-details",
  taskboard: "/task-board",
  projectsList: "/projects",
  projectOverview: "/projects/:projectKey",
  projectBoard: "/projects/:projectKey/board",
  projectBacklog: "/projects/:projectKey/backlog",
  projectIssues: "/projects/:projectKey/issues",
  projectIssueDetails: "/projects/:projectKey/issues/:issueKey",
  projectReports: "/projects/:projectKey/reports",
  projectGantt: "/projects/:projectKey/gantt",
  projectSettings: "/projects/:projectKey/settings",
  projectSettingsMembers: "/projects/:projectKey/settings/members",
  projectSettingsBoard: "/projects/:projectKey/settings/board",
  projectSettingsLabels: "/projects/:projectKey/settings/labels",
  projectSettingsCustomFields: "/projects/:projectKey/settings/custom-fields",
  projectSettingsComponents: "/projects/:projectKey/settings/components",
  projectSettingsVersions: "/projects/:projectKey/settings/versions",
  projectSettingsResolutions: "/projects/:projectKey/settings/resolutions",
  contactGrid: "/contact-grid",
  contactList: "/contact-list",
  contactDetails: "/contact-details",
  companiesGrid: "/companies-grid",
  companiesList: "/companies-list",
  companiesDetails: "/companies-details/:id",
  dealsGrid: "/deals-grid",
  dealsList: "/deals-list",
  dealsDetails: "/deals-details",
  leadsList: "/leads-list",
  leadsqueue: "/leads-queue",
  leadBank: "/lead-bank",
  leadsInQueueHistory: "/leads-queue/history",
  leadsGrid: "/leads-grid",
  facebookLeads: "/facebook-leads",
  whatsAppLeads: "/whatsapp-leads",
  whatsAppLeadsChat: "/whatsapp-leads-chats",
  webhookIntegrations: "/webhook-integrations",
  leadsTransfer: "/leads-transfer",
  dealsTransfer: "/deals-transfer",
  liveCall: "/live-call",
  leadsCall: "/leads-call",
  leadsForm: "/leads-form",
  leadsDetails: "/leads-details",
  pipeline: "/pipeline",
  analytics: "/analytics",
  activities: "/",
  crmSettings: "/crm-settings",
  callLogs: "/call-logs",

  //HRM
  employeeList: "/employees",
  employeeGrid: "/employees-grid",
  departments: "/departments",
  designations: "/designations",
  policy: "/policy",
  holidays: "/hrm/holidays",
  leaveadmin: "/leaves",
  empLeaveSummaryForAdmin: "/leaves/summary/:empId",
  leaveemployee: "/leaves-employee",
  leavesettings: "/leave-settings",
  leaveBalanceAuditLog: "/leave-settings/audit-log",
  attendanceadmin: "/attendance-admin",
  employeeAttendanceLogsForAdmin: "/attendance-admin/logs",
  payrollReport: "/attendance/payroll-report",
  holidayUpload: "/holiday-upload",
  attendanceemployee: "/attendance-employee",
  attendancesettings: "/attendance-settings",
  timesheet: "/timesheets",
  scheduletiming: "/schedule-timing",
  overtime: "/overtime",
  settings: "/settings",
  promotion: "/promotion",
  resignation: "/resignation",
  termination: "/termination",
  ticketCategories: "/ticket-categories",

  // RECRUITMENT
  jobgrid: "/recruitment/jobs",
  hiringSetting: "/recruitment/settings",
  refferal: "/recruitment/refferals",
  referCandidates: "/recruitment/refer-candidates",
  applicationsList: "/recruitment/applications",
  candidateDetails: "/recruitment/applications/candidate/:id",
  interviewList: "/recruitment/interviews",
  recruitmentCandidatesList: "/recruitment/candidates",
  recruitmentCandidateView: "/recruitment/candidates/:id",

  candidatesRequestForm: "/candidates-form",
  candidatesGrid: "/candidates-grid",
  candidateskanban: "/candidates-kanban",
  candidatesInvitation: "/candidates-invitation",
  candidateslist: "/candidates",
  candidateUploadPortal: "/recruitment/upload/:token",
  thankYou: "/thank-you",
  jobdashboard: "/job-dashboard",

  //FINANCE & ACCOUNTS
  estimate: "/estimates",
  invoices: "/invoices",
  addinvoice: "/add-invoices",
  editinvoice: "/edit-invoices",
  invoicesdetails: "/invoice-details",
  payments: "/payments",
  expenses: "/expenses",
  providentfund: "/provident-fund",
  taxes: "/taxes",
  invoiceDetails: "/invoice-details",
  employeesalary: "/employee-salary",
  payslip: "/payslip",
  payrollAddition: "/payroll",
  payrollOvertime: "/payroll-overtime",
  payrollDeduction: "/payroll-deduction",

  //ADMINISTRATION
  knowledgebase: "/knowledgebase",
  activity: "/activity",
  users: "/users",
  rolePermission: "/roles-permissions",
  permissionpage: "/permission",
  assetCategories: "/asset-categories",
  assetProducts: "/asset-products",
  assetStocks: "/asset-stocks",
  assetList: "/assets",
  assetLocations: "/asset-locations",
  assignAssets: "/assign-assets",

  //Report
  expensesreport: "/expenses-report",
  invoicereport: "/invoice-report",
  paymentreport: "/payment-report",
  projectreport: "/project-report",
  taskreport: "/task-report",
  userreport: "/user-report",
  employeereport: "/employee-report",
  employeedetails: "/employee-details/:id",
  payslipreport: "/payslip-report",
  attendancereport: "/attendance-report",
  leavereport: "/leave-report",
  dailyreport: "/daily-report",

  //configuration
  configuration: "/configuration",
  fonada: "/configuration/fonada",

  // ERS - Reports
  ersReportsOverview: "/ers/reports",
  ersReportsCreate: "/ers/reports/create",
  ersReportsEdit: "/ers/reports/edit",

  // ERS - Team Reports
  ersTeamReportsOverview: "/ers/team-reports",

  // ERS - Reports Setting
  ersReportsSettingReportType: "/ers/reports-settings/report-type",

  // AUTOMATIONS - Dynamic routes for all modules
  automationCreate: "/automation/:module/create", // Create
  automationEdit: "/automation/:module/edit/:id", // Edit
  automationHistory: "/automation/:module/history/:id", // Execution History
  assetsAutomation: "/automation/assets",
  leadsAutomation: "/automation/leads",
  attendanceAutomation: "/automation/attendance",
  dealsAutomation: "/automation/deals",
  taskManagerAutomation: "/automation/tasks",
  calendarAutomation: "/automation/calendar",
  employeeReportingAutomation: "/automation/employee-reporting",
  ticketsAutomation: "/automation/tickets",

  // Public Add Lead Form
  publicLeadForm: "/public/l/forms/:public_id",

  // whatsapp configurations

  whatsappConfigurations: "/configurations/whatsapp",
  whatsappTemplates: "/configurations/whatsapp/:configId/templates",
  whatsappMessageLogs:
    "/configurations/whatsapp/:configId/templates/:templateId/logs",

  // Public Recruitment
  careerPage: "/careers",
  careerPagePublic: "/careers/:career_page_uuid",
  careerJobDetailsPublic: "/careers/:career_page_uuid/job/:jobId",
  applicationTracking: "/careers/track-application/:applicationId",
  candidateDashboard: "/careers/:career_page_uuid/profile",
  jobDetails: "/recruitment/jobs/:id",
  publicFeedback: "/public/feedback/:token",
  publicScheduling: "/public/schedule/:token",
};
